import { EffectCallback, useRef, useEffect } from "react";

function useEffectOnce(callBack: EffectCallback) {
    const hasExecuted = useRef(false);

    useEffect(() => {
        if (hasExecuted.current) {
            return;
        }

        hasExecuted.current = true;

        callBack();
    });
}

export default useEffectOnce;